<h1 mat-dialog-title>{{claimedReward ? 'Editing Claimed Reward' : 'Add Claimed Reward'}}</h1>
<h4 *ngIf="claimedReward">{{claimedReward.id}}</h4>

<form [formGroup]="form" class="form">
  <mat-form-field appearance="outline">
    <mat-label>Reward ID</mat-label>
    <input matInput formControlName="rewardId">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Created At</mat-label>
    <input matInput formControlName="createdAt">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Status</mat-label>
    <input matInput formControlName="status">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>User ID</mat-label>
    <input matInput formControlName="userId">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Goal ID</mat-label>
    <input matInput formControlName="goalId">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Task ID</mat-label>
    <input matInput formControlName="taskId">
  </mat-form-field>

  <mat-form-field appearance="outline" class="json-field">
    <mat-label>Parameters</mat-label>
    <app-json formControlName="parameters" baseTable="rewardsClaimed" fieldHint="parameters"></app-json>
  </mat-form-field>

  <mat-form-field appearance="outline" class="json-field">
    <mat-label>Form Data</mat-label>
    <app-json formControlName="formData" baseTable="rewardsClaimed" fieldHint="formData"></app-json>
  </mat-form-field>

  <div class="buttons" mat-dialog-actions>
    <button mat-raised-button color="primary" [disabled]="form.invalid || saving" (click)="save()">Save</button>
    <button mat-stroked-button color="warn" *ngIf="claimedReward" (click)="delete()">Delete</button>
    <button mat-button (click)="cancel()">Cancel</button>
  </div>
</form>
